import React from 'react';
import { Form, Input, Switch, Space, Divider } from 'antd';
import { MinusCircleOutlined } from '@ant-design/icons';
import { Delete03Icon } from '../../../components/icons';

const DiseaseFormItem = ({ name, restField, onRemove }) => {
  return (
    <Space
      style={{ display: 'flex', marginBottom: 8, alignItems: 'start', justifyContent: 'space-between' }}
      align="baseline"
      split={<Divider type="vertical" className="h-16" />}
    >
      <Form.Item
        {...restField}
        name={[name, 'name']}
        label="Disease Name"
        className="w-48"
        rules={[{ required: true, message: 'Missing disease name' }]}
      >
        <Input placeholder="Disease Name" />
      </Form.Item>
      <Form.Item
        {...restField}
        name={[name, 'is_studied']}
        label="Is Studied"
        valuePropName="checked"
        className="w-48"
        rules={[{ required: true, message: 'Missing endpoint category' }]}
      >
        <Switch />
      </Form.Item>

      <Delete03Icon onClick={onRemove} className="cursor-pointer h-4 w-4 text-red-500" />
    </Space>
  );
};

export default DiseaseFormItem;
